import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActionDataResult } from '../../../shared/models/core/ActionDataResult';
import { FactorService } from '../factor.service';
import { NotificationService } from '../../../core/services/notification.service';
import { FactorSet } from '../../../shared/models/Factor/FactorSet';
import { AppService } from '../../../app.service';
import { FilterStorage } from '../../../shared/components/filter-storage/filter-storage'; 
import { ListPageBase } from '../../../shared/components/list-page-base/list-page-base';

@Component({
	selector: 'settings-factors',
	templateUrl: './list.page.html',
	styleUrls: ['./list.page.scss']
})
export class FactorListPage extends ListPageBase implements OnInit {

	public factorSets: ActionDataResult<FactorSet[]>;
	public hasActive: boolean = true;

	constructor(
		appService: AppService,
		router: Router,
		filterStorage: FilterStorage,
		private factorService: FactorService,
		private notificationService: NotificationService) {

		super(appService, router, filterStorage, factorService);

		this.appService.pageTitle = "Коэффициенты";
	}

	ngOnInit(): void {
		super.ngOnInit();

		this.factorService.hasActive().subscribe(x => this.hasActive = x.data);
	}

	loadData(): void {
		super.loadData();

		this.factorService.list(this.state).subscribe(data => {
			this.loading = false;
			return this.factorSets = data;
		});
	}

	public cellClick({ dataItem }: any): void {
		this.router.navigate(['/settings/factor', dataItem.factorSetId]);
	}
}